"use client";
import {Pagination, Table} from "flowbite-react";
import React from "react";
import {useNavigate} from 'react-router-dom';
import LoadSpinner from "../../Common/LoadSpinner";


export const AdminTable = ({dataFetched, headers, data, paginationData, basePath, paginator, onPageChange: customOnPageChange}) => {
    const navigate = useNavigate();

    const onPageChange = (page) => {
        if (customOnPageChange) {
            customOnPageChange(page);
        } else {
            navigate(`${basePath}/${page}/${paginator.per_page}`);
        }
    }

    if (!dataFetched) return <div className="sl-table-container">
        <div className="sl-self-center sl-mt-3 sl-mb-21">
            <LoadSpinner/>
        </div>
    </div>

    return (<div className="sl-table-container">
            <div className="overflow-x-auto border-solid border-1 sl-border-radius-8 sl-gap-4">
                <Table>
                    <Table.Head
                        className="sl-bg-gray-50 sl-border sl-rounded-top-lg sl-border-solid sl-border-gray-200">
                        {headers.map((header, index) => (
                            <Table.HeadCell
                                className={`sl-font sl-font-medium sl-text-sm sl-text-center sl-text-gray-700 sl-py-12 sl-px-16 sl-px-2 ${header.classes}`}
                                key={index}>{header.data}</Table.HeadCell>
                        ))}
                    </Table.Head>

                    <Table.Body className="divide-y">
                        {data.map((row, index) => (
                            <Table.Row key={index} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                                {Object.values(row).map((value, index) => (
                                    <Table.Cell
                                        onClick={value.onClick}
                                        key={index}
                                        className={`sl-font sl-font-medium sl-text-sm sl-text-center sl-text-gray-700 sl-py-12 sl-px-16  sl-px-2 ${value.classes ? value.classes : 'sl-min-w-33'}`}
                                    >
                                        <span className={value.classes}>{value.data}</span>
                                    </Table.Cell>
                                ))}
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>

                {paginationData?.total_pages && <div className="flex overflow-x-auto sm:justify-center sl-p-4">
                    <Pagination currentPage={paginationData.current_page} totalPages={paginationData.total_pages}
                                onPageChange={onPageChange}/>
                </div>}
            </div>
        </div>
    )

}
